export default {"src":"/_next/static/media/payment-icons.5ca7a4e2.svg","height":21,"width":308,"blurWidth":0,"blurHeight":0};